export default __webpack_public_path__ + "static/media/logo-ambiente-piu-NC.2827faf0.svg";